// 语言判定的纯逻辑（不碰 window/localStorage，node --test 可直接 import）。
//
// 判定结果带来源，因为"显示什么语言"和"什么语言算访客/集成方的明确意图"是两件事：
// 只有 manual / integrator 才会作为 language 上报服务端，见 initLanguageFields。
//
// 优先级：
//   manual       访客在 widget 里亲手选的（localStorage）
//   integrator   laneChatCustomizations.lang / laneChatLang（含原生 SDK 拼的 ?lang=）
//   page_default widget.html 没带 ?lang= 时自带的 en 默认，只决定显示，不算任何人的意图
//   browser      navigator.languages
//   host_page    宿主页 <html lang>，排在浏览器之后，浏览器语言都不受支持时才用
//   fallback     en
//
// 宿主页 <html lang> 曾排在浏览器之前，而且判定结果每次 init 都以 sdk_param 写进
// clients.preferred_language：英文浏览器访客进了 lang="zh" 的站点，后续所有服务端
// 文案和 AI 回复都变成中文。<html lang> 描述的是这张页面，不是这位访客。

const LANG_ALIASES = { in: 'id', iw: 'he', ji: 'yi', tl: 'fil' };

export function normalizeLang(raw, supported) {
    if (!raw || typeof raw !== 'string') return null;
    // 'zh_CN' / 'zh-Hans-CN' / 'PT-br' 一律取主子标签
    const base = raw.toLowerCase().trim().replace(/_/g, '-').split('-')[0];
    if (!base) return null;
    const code = LANG_ALIASES[base] || base;
    return supported.indexOf(code) !== -1 ? code : null;
}

export function resolveLangDetailed(env) {
    const supported = env.supported;
    const norm = (raw) => normalizeLang(raw, supported);

    const manual = norm(env.stored);
    if (manual) return { lang: manual, source: 'manual' };

    const custom = norm(env.customizationLang);
    if (custom) return { lang: custom, source: 'integrator' };

    const global = norm(env.globalLang);
    if (global) return { lang: global, source: env.globalLangIsDefault ? 'page_default' : 'integrator' };

    for (const raw of env.navigatorLangs || []) {
        const hit = norm(raw);
        if (hit) return { lang: hit, source: 'browser' };
    }

    const host = norm(env.htmlLang);
    if (host) return { lang: host, source: 'host_page' };

    return { lang: 'en', source: 'fallback' };
}

// /v1/chat init 的语言字段。自动判定的结果一律不报：服务端按 Accept-Language 和
// visitor_sessions.language 自己判，且首条消息还会校正一次。
export function initLanguageFields(resolved) {
    if (resolved.source === 'manual') return { language: resolved.lang, language_manual: 1 };
    if (resolved.source === 'integrator') return { language: resolved.lang };
    return {};
}
